import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Primary as PrimaryButton } from "@churchofjesuschrist/eden-buttons";
import { H6 as EdenH6 } from "@churchofjesuschrist/eden-headings";
import { borderColorSecondary, spacing16, spacing8 } from "@churchofjesuschrist/eden-style-constants";
import Row from "@churchofjesuschrist/eden-row";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HR = styled.hr.withConfig({
  componentId: "sc-w1uryr-0"
})(["border:none;border-block-start:1px solid ", ";height:1px;"], borderColorSecondary);
const Root = styled.div.withConfig({
  componentId: "sc-w1uryr-1"
})(["width:100%;position:relative;display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));grid-gap:2rem 1.5rem;"]);
const H6 = styled(EdenH6).withConfig({
  componentId: "sc-w1uryr-2"
})(["padding:0 ", " 0 ", ";"], spacing16, spacing8);
const DownloadOptions = _ref => {
  let {
    items = [],
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(Root, {
    ...props,
    children: items.map((_ref2, sectionIndex) => {
      let {
        title,
        items
      } = _ref2;
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(H6, {
          renderAs: "div",
          children: title
        }), /*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(Row, {
          children: items.map((_ref3, itemIndex) => {
            let {
              text,
              ...rest
            } = _ref3;
            return /*#__PURE__*/_jsx(PrimaryButton, {
              small: true,
              ...rest,
              children: text
            }, itemIndex);
          })
        })]
      }, sectionIndex);
    })
  });
};
DownloadOptions.propTypes = {
  /** Array of download types (PDF, mp3, png, etc.) with their options (small, large, etc.). Each item should look like this:
   * ```js
   *    PropTypes.shape({
   *      title: PropTypes.string,
   *      items: PropTypes.arrayOf(
   *        PropTypes.shape({
   *          text: PropTypes.string,
   *          href: PropTypes.string
   *        })
   *      )
   *    })
   * ```
   */
  items: PropTypes.array
};
export default DownloadOptions;